export default __webpack_public_path__ + "static/media/group-3-copy@2x.a9293a95.png";